/* ==========================================================================
   as-header-a11y.js
   Keyboard / focus accessibility layer for the desktop mega-menu.
   ========================================================================== */
(function () {
  function init() {
    var isDesktop = function () {
      return window.matchMedia("(min-width: 1100px)").matches;
    };

    var headerWrapper = document.querySelector(".as-header-wrapper");
    var nav = document.querySelector(".as-header__nav");
    if (!nav) return;

    var detailsEls = Array.prototype.slice.call(
      nav.querySelectorAll(".as-header__details"),
    );
    if (!detailsEls.length) return;

    function triggerOf(details) {
      return details.querySelector(".as-header__summary");
    }

    function submenuOf(details) {
      return details.querySelector(".as-header__submenu");
    }

    function firstFocusableInSubmenu(details) {
      var submenu = submenuOf(details);
      if (!submenu) return null;

      return submenu.querySelector(
        ".as-header__submenu-link, a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])",
      );
    }

    function activateSubmenuItem(item) {
      if (!item) return;

      var details = item.closest(".as-header__details");
      if (!details) return;

      var handle = item.dataset ? item.dataset.handle : null;

      details
        .querySelectorAll(".as-header__submenu-item")
        .forEach(function (el) {
          el.classList.remove("is-active");
        });

      item.classList.add("is-active");

      details
        .querySelectorAll(".submenu-products-wrap")
        .forEach(function (block) {
          block.hidden = true;
        });

      if (handle) {
        var target = details.querySelector(
          '.submenu-products-wrap[data-handle="' + handle + '"]',
        );

        if (target) target.hidden = false;
      }
    }

    function setExpanded(details, value) {
      details.setAttribute("data-expanded", value);

      var trigger = triggerOf(details);
      if (trigger) trigger.setAttribute("aria-expanded", value);
    }

    function openDetails(details) {
      setExpanded(details, "true");

      if (headerWrapper) {
        headerWrapper.classList.add("is-mega-open");
      }

      var activeItem = details.querySelector(
        ".as-header__submenu-item.is-active",
      );
      var firstItem = details.querySelector(".as-header__submenu-item");

      if (activeItem) {
        activateSubmenuItem(activeItem);
      } else if (firstItem) {
        activateSubmenuItem(firstItem);
      }
    }

    function closeDetails(details) {
      setExpanded(details, "false");

      var anyOpen = nav.querySelector(
        '.as-header__details[data-expanded="true"]',
      );

      if (!anyOpen && headerWrapper) {
        headerWrapper.classList.remove("is-mega-open");
      }
    }

    function closeAll() {
      detailsEls.forEach(function (details) {
        setExpanded(details, "false");
      });

      if (headerWrapper) {
        headerWrapper.classList.remove("is-mega-open");
      }
    }

    detailsEls.forEach(function (details) {
      var trigger = triggerOf(details);
      var submenu = submenuOf(details);

      if (!trigger) return;

      trigger.setAttribute("aria-haspopup", "true");
      trigger.setAttribute("aria-expanded", "false");

      if (submenu && submenu.id) {
        trigger.setAttribute("aria-controls", submenu.id);
      }

      var mo = new MutationObserver(function () {
        var open = details.getAttribute("data-expanded") === "true";
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
      });

      mo.observe(details, {
        attributes: true,
        attributeFilter: ["data-expanded"],
      });

      trigger.addEventListener("focus", function () {
        if (!isDesktop()) return;

        detailsEls.forEach(function (d) {
          if (d !== details) setExpanded(d, "false");
        });

        openDetails(details);
      });

      trigger.addEventListener("keydown", function (e) {
        if (!isDesktop()) return;

        if (e.key === "ArrowDown") {
          e.preventDefault();

          openDetails(details);

          var first = firstFocusableInSubmenu(details);
          if (first) {
            var firstItem = first.closest(".as-header__submenu-item");
            activateSubmenuItem(firstItem);
            first.focus();
          }
        }

        if (e.key === "Escape") {
          e.preventDefault();
          closeDetails(details);
        }

        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();

          var idx = detailsEls.indexOf(details);
          var next;

          if (e.key === "ArrowRight") {
            next = detailsEls[idx + 1] || detailsEls[0];
          } else {
            next = detailsEls[idx - 1] || detailsEls[detailsEls.length - 1];
          }

          closeDetails(details);

          var nextTrigger = triggerOf(next);
          if (nextTrigger) nextTrigger.focus();
        }
      });

      submenu.addEventListener("keydown", function (e) {
        if (!isDesktop()) return;

        if (e.key === "Escape") {
          e.preventDefault();
          closeDetails(details);
          trigger.focus();
          return;
        }

        var list = submenu.querySelector(".as-header__submenu-list");
        var links = list
          ? Array.prototype.slice.call(
              list.querySelectorAll(".as-header__submenu-link"),
            )
          : [];

        var currentLink = document.activeElement.closest(
          ".as-header__submenu-link",
        );
        var currentItem = currentLink
          ? currentLink.closest(".as-header__submenu-item")
          : details.querySelector(".as-header__submenu-item.is-active");

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          if (!links.length) return;

          e.preventDefault();

          var idx = links.indexOf(currentLink);
          var nextLink;

          if (e.key === "ArrowDown") {
            nextLink = idx === -1 ? links[0] : links[idx + 1] || links[0];
          } else {
            nextLink =
              idx === -1
                ? links[links.length - 1]
                : links[idx - 1] || links[links.length - 1];
          }

          var nextItem = nextLink.closest(".as-header__submenu-item");

          activateSubmenuItem(nextItem);
          nextLink.focus();

          return;
        }

        if (e.key === "ArrowRight") {
          e.preventDefault();

          if (!currentItem) return;

          activateSubmenuItem(currentItem);

          var handle = currentItem.dataset ? currentItem.dataset.handle : null;
          if (!handle) return;

          var activeProducts = details.querySelector(
            '.submenu-products-wrap[data-handle="' + handle + '"]',
          );

          if (!activeProducts || activeProducts.hidden) return;

          var firstProductLink = activeProducts.querySelector(
            'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
          );

          if (firstProductLink) firstProductLink.focus();

          return;
        }

        if (e.key === "ArrowLeft") {
          var productWrap = document.activeElement.closest(
            ".submenu-products-wrap",
          );

          if (!productWrap) return;

          e.preventDefault();

          var handle = productWrap.dataset ? productWrap.dataset.handle : null;
          if (!handle) return;

          var relatedItem = details.querySelector(
            '.as-header__submenu-item[data-handle="' + handle + '"]',
          );

          var relatedLink = relatedItem
            ? relatedItem.querySelector(".as-header__submenu-link")
            : null;

          if (relatedLink) relatedLink.focus();

          return;
        }
      });
    });

    document.addEventListener("focusin", function (e) {
      if (!isDesktop()) return;

      if (!nav.contains(e.target)) {
        closeAll();
      }
    });

    var burger = document.querySelector(".as-mob-header__burger");
    var mobDrawer = document.querySelector(".as-mob-drawer");

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getDrawerFocusable() {
      if (!mobDrawer) return [];
      return Array.prototype.slice.call(mobDrawer.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return !el.closest('[hidden]');
      });
    }

    if (burger && headerWrapper) {
      new MutationObserver(function () {
        var open = headerWrapper.classList.contains("as-header-wrapper--open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
        burger.setAttribute("aria-label", open ? "Close menu" : "Open menu");

        if (open && mobDrawer) {
          var first = getDrawerFocusable()[0];
          if (first) first.focus();
        }
      }).observe(headerWrapper, { attributes: true, attributeFilter: ["class"] });
    }

    document.addEventListener("keydown", function (e) {
      if (isDesktop()) return;
      if (!headerWrapper) return;
      if (!headerWrapper.classList.contains("as-header-wrapper--open")) return;

      if (e.key === "Escape") {
        e.preventDefault();
        headerWrapper.classList.remove("as-header-wrapper--open");
        document.body.classList.remove("as-fixed");
        if (burger) burger.focus();
        return;
      }

      if (e.key === "Tab") {
        var focusable = getDrawerFocusable();
        if (burger) focusable = [burger].concat(focusable);
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });

    if (mobDrawer) {
      mobDrawer.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;

        var focused = document.activeElement;

        if (!focused || !focused.classList.contains("as-mob-link")) return;

        var list = focused.closest(".as-mob-list");
        if (!list) return;

        var items = Array.prototype.slice.call(
          list.querySelectorAll(".as-mob-link"),
        );

        var idx = items.indexOf(focused);
        if (idx === -1) return;

        e.preventDefault();

        var target;

        if (e.key === "ArrowDown") {
          target = items[idx + 1] || items[0];
        } else {
          target = items[idx - 1] || items[items.length - 1];
        }

        target.focus();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
